import PropTypes from 'prop-types';
import React from 'react';
import styles from './AddToCalendarMobile.scss';
import classNames from 'classnames';
import SvgX from 'wix-style-react/new-icons/X';
import {Link} from 'react-router';
import generateAddToCalendarHref from '../../utils/calendarUtils';

export class CancelReservation extends React.Component {
  render() {
    const {i18n, reservation, organization} = this.props;

    return (
      <div className={styles.addToCalendarMobile}>
        <div className={styles.closeButton}>
          <Link className={classNames(styles.button, styles.smallButton, styles.backButton)} to={this.props.home}>
            <span className={styles.closeButtonInner}>
              <SvgX thickness={1} color={'#20455e'}/>
            </span>
          </Link>
        </div>
        <div className={styles.title}>{i18n.get('modify_reservation_add_to_calendar', 'Add To Calendar')}</div>
        <div className={styles.subTitle}>{i18n.get('modify_reservation_add_to_calendar_sub_title', 'Add to celendar subtitle')}</div>
        <div className={styles.items}>
          <a
            {...generateAddToCalendarHref(reservation, organization, 'google')}
            className={styles.item}
            target="_blank"
            rel="noopener noreferrer"
            data-hook="wixrest-add-reservation-to-calendar-mobile-step-2-google"
            >
            Google Calendar
          </a>
          <a
            {...generateAddToCalendarHref(reservation, organization, 'ical')}
            className={classNames(styles.item, styles.itemPadding)}
            target="_blank"
            rel="noopener noreferrer"
            data-hook="wixrest-add-reservation-to-calendar-mobile-step-2-ical"
            >
            iCalendar
          </a>
          <a
            {...generateAddToCalendarHref(reservation, organization, 'outlook')}
            className={styles.item}
            target="_blank"
            rel="noopener noreferrer"
            data-hook="wixrest-add-reservation-to-calendar-mobile-step-2-outlook"
            >
            Outlook
          </a>
        </div>
        <div className={styles.placeholder}/>
        <div className={classNames(styles.divider, styles.bottomDivider)}/>
        <div className={styles.buttons}>
          <Link
            className={classNames(styles.button, styles.backButton, styles.bottomButton)}
            to={this.props.home}
            data-hook="wixrest-add-reservation-to-calendar-mobile-back"
            >
            {i18n.get('modify_reservation_back', 'Back')}
          </Link>
        </div>
      </div>
    );
  }
}

CancelReservation.displayName = 'AddToCalendarMobile';
CancelReservation.propTypes = {
  i18n: PropTypes.object,
  reservation: PropTypes.object,
  organization: PropTypes.object.isRequired,
  home: PropTypes.string
};

export default CancelReservation;



// WEBPACK FOOTER //
// ./components/AddToCalendarMobile/AddToCalendarMobile.js